// src/redux/reducers/roleReducer.js
import { SET_PERMISSIONS } from "../actions/actionTypes"
import {
  USER_ID_LIST_SUCCESS,
  USER_ID_LIST_FAILURE,
} from "../actions/userActions"

const initialState = {
  permissions: null, // null distinguishes "not loaded" from "loaded empty" — was []
}

const handleSetPermissions = (state, action) => {
  const prev = state.permissions
  const next = action.payload
  const sameUser =
    prev?.userInfo?.user_id != null &&
    prev.userInfo.user_id === next?.userInfo?.user_id
  const carried =
    sameUser && prev.scopePending === false
      ? {
          facilities: prev.facilities,
          specialties: prev.specialties,
          scopePending: false,
        }
      : null
  return {
    loading: false,
    permissions: carried && next ? { ...next, ...carried } : next,
    error: "",
  }
}

const handleUserIdListSuccess = (state, action) => {
  if (!state.permissions) return state
  const me = Array.isArray(action.payload) ? action.payload[0] : null
  const myId = state.permissions.userInfo?.user_id
  if (me) {
    if (myId == null || String(me.user_id) !== String(myId)) return state
    return {
      ...state,
      permissions: {
        ...state.permissions,
        facilities: Array.isArray(me.facilities) ? me.facilities : [],
        specialties: Array.isArray(me.specialties) ? me.specialties : [],
        scopePending: false,
      },
    }
  }
  if (state.permissions.scopePending !== true) return state
  return {
    ...state,
    permissions: {
      ...state.permissions,
      facilities: [],
      specialties: [],
      scopePending: false,
    },
  }
}

const handleUserIdListFailure = (state) => {
  if (!state.permissions) return state
  return {
    ...state,
    permissions: { ...state.permissions, scopePending: false },
  }
}

const handlers = {
  [SET_PERMISSIONS]: handleSetPermissions,
  [USER_ID_LIST_SUCCESS]: handleUserIdListSuccess,
  [USER_ID_LIST_FAILURE]: handleUserIdListFailure,
}

const roleReducer = (state = initialState, action) => {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}

export default roleReducer
